import { createRequestTypes } from 'common/websocket-redux';

export const REQUEST_SET_PROMO_CODE = createRequestTypes(
  'script-helpers/SET_PROMO_CODE',
);
